const BowUse = require('../ability_trees/BowUse.js');
const Movement = require('../ability_trees/Movement.js');
const Spirit = require('../ability_trees/Spirit.js');
const StandardAbilityTree = require('../ability_trees/StandardAbilityTree.js');

const ItemGenerator = require('../../game_items/ItemGenerator.js');
const MedHelmet = require('../../game_items/equipment/helmet/MedHelmet.js');
const MedTorsoe = require('../../game_items/equipment/torsoe/MedTorsoe.js');
const MedBoots = require('../../game_items/equipment/boots/MedBoots.js');
const Bow = require('../../game_items/equipment/off_hand/Bow.js');

module.exports = {
  handle: 'ranger',
  getAbilityTrees: () => ([
    BowUse,
    Movement,
    Spirit,
    StandardAbilityTree,
  ]),
  getBaseAttributes: () => ({
    learning: 5,
    perception: 9,
    mana: 6,
    toughness: 6,
    strength: 7,
    willpower: 7,
    dexterity: 10,
  }),
  getDefaultAIConfig: () => (['dps_ranged', 'support', 'interference', 'tank', 'dps_close']),
  getStarterEquipment: () => ({
    helmet: ItemGenerator.getRandomItem(MedHelmet, 0, 0.1, true),
    torsoe: ItemGenerator.getRandomItem(MedTorsoe, 0, 0.1, true),
    boots: ItemGenerator.getRandomItem(MedBoots, 0, 0.1, true),
    off_hand: ItemGenerator.getRandomItem(Bow, 0, 0.1, true),
  }),
};
